import {
  GRID_COL_INDEX_ATTRIBUTE,
  GridCellProps
} from '@progress/kendo-react-grid';
import React from 'react';
import { useTableKeyboardNavigation } from '@progress/kendo-react-data-tools';
import { Button } from '@progress/kendo-react-buttons';
import { ThemeColor } from '../../types/theme-color';

export interface ActionButtonDefinition {
  /** Click handler for the button */
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  /** Material Symbols icon name (e.g. 'visibility', 'edit', 'delete') */
  icon: string;
  /** Kendo theme color. Defaults to 'primary' */
  themeColor?: ThemeColor;
  /** Tooltip / title text for the button */
  title?: string;
  isDisable?: boolean;
}

export interface ActionButtonsCellProps extends GridCellProps {
  /** Array of button definitions to render in the cell */
  actions: ActionButtonDefinition[];
}

export const ActionButtonsCell = ({
  actions,
  ...props
}: ActionButtonsCellProps) => {
  const navigationAttributes = useTableKeyboardNavigation(props.id);
  return (
    <td
      className={'k-table-td'}
      colSpan={props.colSpan}
      role={'gridcell'}
      aria-colindex={props.ariaColumnIndex}
      aria-selected={props.isSelected}
      {...{ [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex }}
      {...navigationAttributes}>
      <div
        className={
          'd-flex justify-content-center align-items-center flex-nowrap'
        }
        style={{ minWidth: 'max-content' }}>
        {actions.map((action, index) => (
          <Button
            key={index}
            onClick={action.onClick}
            themeColor={action.themeColor ?? 'primary'}
            size={'small'}
            className={'small'}
            fillMode={'flat'}
            title={action.title}
            disabled={action.isDisable}>
            <span className={'material-symbols-outlined'}>{action.icon}</span>
          </Button>
        ))}
      </div>
    </td>
  );
};

export default ActionButtonsCell;
